export const API_START = 'API_START';
export const API_FAIL = 'API_FAIL';
export const API_COMPLETE = 'API_COMPLETE';
export const GET_USER_HMG_DATA_SUCCESS = 'GET_USER_HMG_DATA_SUCCESS';
export const GET_USER_HOTELS_SUCCESS = 'GET_USER_HOTELS_SUCCESS';
export const GET_USER_HOTELS_REPORTS_SUCCESS = 'GET_USER_HOTELS_REPORTS_SUCCESS';
export const STRM_REPORT_DATA_APPLY_SUCCESS = 'STRM_REPORT_DATA_APPLY_SUCCESS';
export const GET_FILTRD_QMS_REPORTS_SUCCESS = 'GET_FILTRD_QMS_REPORTS_SUCCESS';

export const SET_CONTENT_LOADING = "SET_CONTENT_LOADING";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_SIDEBAR_SOLUTION = "SET_SIDEBAR_SOLUTION";
export const SET_CONTROLLED_FILTERS_OPEN = "SET_CONTROLLED_FILTERS_OPEN";
export const SET_LOADER = "SET_LOADER";
export const SET_SIDEBAR_SELECTED = "SET_SIDEBAR_SELECTED";

export const GET_QMS_STAGE03_DUMMY_DATA = "GET_QMS_STAGE03_DUMMY_DATA";
export const GET_COMPLIANCE_TABLE_DATA_SUCCESS = "GET_COMPLIANCE_TABLE_DATA_SUCCESS";
export const GET_COMPLIANCE_TABLE_DATA_ERROR = "GET_COMPLIANCE_TABLE_DATA_ERROR";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_HOLISTIC_DATA_SUCCESS = "GET_HOLISTIC_DATA_SUCCESS";
export const GET_APP_CONFIG_DATA_SUCCESS = "GET_APP_CONFIG_DATA_SUCCESS";
export const GET_EXCEL_EXPORT_DATA_SUCCESS = "GET_EXCEL_EXPORT_DATA_SUCCESS";
export const SET_COMPLIANCE_PERCENTAGE = "SET_COMPLIANCE_PERCENTAGE";
export const SET_COMPLIANCE_MAIN_TAB_DATA = "SET_COMPLIANCE_MAIN_TAB_DATA";
export const SET_COMPLIANCE_MAIN_ACTIVE_TAB= "SET_COMPLIANCE_MAIN_ACTIVE_TAB";
export const SET_COMPLIANCE_MAIN_DISABLED_TAB= "SET_COMPLIANCE_MAIN_DISABLED_TAB";

export const TOGGLE_COMPLIANCE_STATUS_VIEW = "TOGGLE_COMPLIANCE_STATUS_VIEW";
export const TOGGLE_COMPLIANCE_DATE_VIEW = "TOGGLE_COMPLIANCE_DATE_VIEW";
export const SET_COMPLIANCE_DEFAULT_LOAD = "SET_COMPLIANCE_DEFAULT_LOAD";

//COMP PERMISSIONS
export const SET_COMPLIANCE_APP_PERMISSONS = "SET_COMPLIANCE_APP_PERMISSONS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_COMPLIANCE_CONFIG = "SET_COMPLIANCE_CONFIG";

export const RESEND_ENVELOP_TO_NOT_SIGNED_SUCCESS = "RESEND_ENVELOP_TO_NOT_SIGNED_SUCCESS";
export const RESEND_ENVELOP_TO_NOT_SIGNED_FAILED = "RESEND_ENVELOP_TO_NOT_SIGNED_FAILED";
export const CLEAR_RESEND_STATE = "CLEAR_RESEND_STATE";

export const TOGGLE_SIGNATURE_MODAL_VISIBILITY = "TOGGLE_SIGNATURE_MODAL_VISIBILITY";
export const SET_SIGNATURE_MODAL_DATA = "SET_SIGNATURE_MODAL_DATA";

export const SET_POPUP_OPEN = "SET_POPUP_OPEN";
export const CREATE_POPUP_MATRIX = "CREATE_POPUP_MATRIX";
export const SET_POPUP_MATRIX_STATUS = "SET_POPUP_MATRIX_STATUS";
export const RESET_POPUP_MATRIX = "RESET_POPUP_MATRIX";

//Grouping modal
export const GROUP_MODAL_VISIBILITY = "GROUP_MODAL_VISIBILITY";
export const TOGGLE_GROUP_MODAL_VISIBILITY = "TOGGLE_GROUP_MODAL_VISIBILITY";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const EDIT_GROUP_SUCCESS = "EDIT_GROUP_SUCCESS";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const GROUP_PROCESS_FAIL = "GROUP_PROCESS_FAIL";


//Compliance Datepicker
// export const UPDATE_DATE_PICKER = "UPDATE_DATE_PICKER";

//Compliance hotelwise report category
export const GET_COMP_REPORT_CAT_SUCCESS = "GET_COMP_REPORT_CAT_SUCCESS";
export const GET_COMP_REPORT_CAT_FAIL = "GET_COMP_REPORT_CAT_FAIL";
